
export type TransactionType = 'expense' | 'income' | 'charge' | 'point' | 'adjustment';

export enum PaymentMethod {
  CASH = '現金',
  CREDIT_CARD = 'クレジットカード',
  DEBIT_CARD = 'デビットカード',
  PREPAID_CARD = 'プリペイドカード', // Kyash, etc.
  E_MONEY = '電子マネー', // Suica, Pasmo, etc.
  QR_CODE = 'QR決済', // PayPay, LinePay, etc.
  BANK_TRANSFER = '銀行振込',
  POINTS = 'ポイント',
  OTHER = 'その他'
}

export enum PointProvider {
  PAYPAY = 'PayPayポイント',
  RAKUTEN = '楽天ポイント',
  DPOINT = 'dポイント',
  PONTA = 'Pontaポイント',
  VPOINT = 'Vポイント', // Formerly T-Point
  OTHER = 'その他ポイント'
}

export enum ExpenseCategory {
  FOOD = '食費',
  TRANSPORT = '交通費',
  SHOPPING = '買い物',
  ENTERTAINMENT = '交際・娯楽',
  UTILITIES = '水道光熱費',
  HOUSING = '住まい',
  HEALTH = '医療・健康',
  EDUCATION = '教養・教育',
  CHARGE = 'チャージ', // Added for top-ups
  OTHER = 'その他'
}

export enum IncomeCategory {
  SALARY = '給与',
  BONUS = '賞与',
  BUSINESS = '事業・副業',
  ALLOWANCE = 'お小遣い',
  INVESTMENT = '投資・配当',
  RETURN = '返金',
  OTHER = 'その他収入'
}

// Union type for all categories
export type Category = ExpenseCategory | IncomeCategory | 'ポイント';

export interface ExpenseItem {
  name: string;
  amount?: number;
}

export interface Transaction {
  id: string;
  type: TransactionType;
  amount: number;
  place: string; 
  method: PaymentMethod; 
  sourceMethod?: PaymentMethod; 
  sourcePaymentDetail?: string; // Detail for source method (e.g. specific bank)
  pointProvider?: PointProvider; // For point transactions
  isPointUsage?: boolean; // true = used (expense-like), false = earned (income-like)
  paymentDetail?: string;
  category: string; 
  items?: ExpenseItem[]; // List of purchased items
  date: string;
  note?: string;
  createdAt: number;
}

export interface ParsedTransactionData {
  type?: TransactionType;
  amount?: number;
  place?: string;
  method?: string; 
  sourceMethod?: string;
  sourcePaymentDetail?: string;
  pointProvider?: string;
  isPointUsage?: boolean;
  paymentDetail?: string;
  category?: string;
  items?: ExpenseItem[];
  date?: string;
  time?: string;
  note?: string;
}

export interface BalanceSettings {
  enabled: boolean;
  displayTotal: boolean;
  includedMethods: string[]; // Can be PaymentMethod or "PaymentMethod:Detail"
  balances: Record<string, number>; // Key is PaymentMethod or "PaymentMethod:Detail"
}

export interface UserSettings {
  monthlyBudget: number;
  balanceSettings?: BalanceSettings;
}

export interface UserPreference {
  displayTotalBalance: boolean;
  hasSetBalancePreference: boolean;
  cachedTotalBalance?: number;
  lastUpdated?: number;
}
